import MessageService from "@/services/message.service";

import axios from 'axios';
const API_URL_WOW_AUDIT = '/service/wow-audit';

class WowAuditService {
    getWowAuditRaids(roster) {
        return axios.get(`${API_URL_WOW_AUDIT}/raids/${roster}`).then(response => {
            return response.data;
        }).catch(error => {
            MessageService.error(`Failed to get raid list. Error: '${error.response.statusText}'`);
            return [];
        });
    }

    getWowAuditRaidDetails(roster, id) {
        return axios.get(`${API_URL_WOW_AUDIT}/raids/detail/${roster}/${id}`).then(response => {
            return response.data;
        }).catch(error => {
            MessageService.error(`Failed to get raid details. Error: '${error.response.statusText}'`);
            return [];
        });
    }

}
export default new WowAuditService();